/** Полный доступ к приложению */
export const FULL_ACCESS_ROLE = 'goplan_full_access';
/** Доступ к разделу Дашборд */
export const GOPLAN_DASHBOARD_ACCESS = 'goplan_dashboard_access';
/** Выбор версии "Опубликованная" на Дашборде */
export const GOPLAN_DASHBOARD_SELECT_PUBLISHED = 'goplan_dashboard_select_published';
/** Выбор версии "Публичный черновик" на Дашборде */
export const GOPLAN_DASHBOARD_SELECT_PUBLIC_DRAFT = 'goplan_dashboard_select_public_draft';
/** Выбор версии "Архивные версии" на Дашборде */
export const GOPLAN_DASHBOARD_SELECT_TEMP_DRAFT = 'goplan_dashboard_select_temp_draft';
/** Доступ к разделу Ковер бурения / График (БУ) на чтение */
export const GOPLAN_DRILLING_CARPET_GRAPH_READ = 'goplan_graph_read';
/** Доступ к разделу Ковер бурения / График (БУ) на редактирование */
export const GOPLAN_DRILLING_CARPET_GRAPH_EDIT = 'goplan_graph_edit';
/** Выбор версии "Опубликованная" в Ковре бурения / График (БУ) */
export const GOPLAN_DRILLING_CARPET_GRAPH_SELECT_PUBLISHED = 'goplan_graph_select_published';
/** Доступ к выбору версии "Публичный черновик" на чтение */
export const GOPLAN_DRILLING_CARPET_GRAPH_SELECT_PUBLIC_DRAFT_READ = 'goplan_graph_select_public_draft_read';
/** Доступ к выбору версии "Публичный черновик" на редактирование */
export const GOPLAN_DRILLING_CARPET_GRAPH_SELECT_PUBLIC_DRAFT_EDIT = 'goplan_graph_select_public_draft_edit';
/** Доступ к созданию и работе с "Личным черновиком" */
export const GOPLAN_DRILLING_CARPET_GRAPH_SELECT_PERSONAL_DRAFT = 'goplan_graph_select_private_draft';
/** Доступ к выбору "Архивных версий" на чтение */
export const GOPLAN_DRILLING_CARPET_GRAPH_SELECT_TEMP_DRAFT_READ = 'goplan_graph_select_temp_draft_read';
/** Возможность отправки версии в аналитику */
export const GOPLAN_DRILLING_CARPET_SEND_TO_ANALYTICS = 'goplan_send_to_analytics';
/** Возможность отправки версии в интеграцию */
export const GOPLAN_DRILLING_CARPET_SEND_TO_INTEGRATION = 'goplan_send_to_integration';
/** Возможность удаления архивных версий */
export const GOPLAN_DRILLING_CARPET_DELETE_TEMP_DRAFT = 'goplan_delete_temp_draft';
/** Возможность отправки личного черновика в интеграцию */
export const GOPLAN_DRILLING_CARPET_SEND_PERSONAL_DRAFT_TO_INTEGRATION = 'goplan_send_private_draft_to_integration';
/** Возможность переименования версии "Опубликованная" */
export const GOPLAN_DRILLING_CARPET_RENAME_PUBLISHED = 'goplan_rename_published';
/** Возможность переименования версии "Публичный черновик" */
export const GOPLAN_DRILLING_CARPET_RENAME_PUBLIC_DRAFT = 'goplan_rename_public_draft';
/** Возможность переименования версии "Личный черновик" */
export const GOPLAN_DRILLING_CARPET_RENAME_PERSONAL_DRAFT = 'goplan_rename_private_draft';
/** Возможность переименования "Архивных версий" */
export const GOPLAN_DRILLING_CARPET_RENAME_TEMP_DRAFT = 'goplan_rename_temp_draft';
/** Возможность сравнения версий */
export const GOPLAN_DRILLING_CARPET_COMPARE_MODE = 'goplan_compare_mode';
/** Возможность публикации "Личного черновика" */
export const GOPLAN_DRILLING_CARPET_PUBLISH_PERSONAL_DRAFT = 'goplan_publish_private_draft';
/** Возможность публикации "Публичного черновика" */
export const GOPLAN_DRILLING_CARPET_PUBLISH_PUBLIC_DRAFT = 'goplan_publish_public_draft';
/** Возможность импорта данных для личного и публичного (админ) */
export const GOPLAN_DRILLING_CARPET_IMPORT_ADMIN = 'goplan_import_admin';
/** Возможность импорта данных только для личного (редактор) */
export const GOPLAN_DRILLING_CARPET_IMPORT_EDITOR = 'goplan_import_editor';
/** Экспорт "Списка скважин" */
export const GOPLAN_DRILLING_CARPET_EXPORT_WELL_LIST = 'goplan_export_well_list';
/** Экспорт "Диаграммы Ганта" */
export const GOPLAN_DRILLING_CARPET_EXPORT_GANTT = 'goplan_export_gantt';
/** Экспорт раздела "Подготовка" */
export const GOPLAN_DRILLING_CARPET_EXPORT_PREPARATION = 'goplan_export_preparation';
/** Возможность создания скважины */
export const GOPLAN_DRILLING_CARPET_CREATE_WELL = 'goplan_create_well';
/** Доступ к разделу Скважины на просмотр */
export const GOPLAN_DRILLING_CARPET_WELLS_ACCESS_READ = 'goplan_wells_access_read';
/** Доступ к разделу Скважины на редактирование */
export const GOPLAN_DRILLING_CARPET_WELLS_ACCESS_EDIT = 'goplan_wells_access_edit';
/** Доступ к разделу Подготовка на просмотр */
export const GOPLAN_DRILLING_CARPET_PREPARATION_ACCESS_READ = 'goplan_preparation_access_read';
/** Доступ к разделу Подготовка на редактирование */
export const GOPLAN_DRILLING_CARPET_PREPARATION_ACCESS_EDIT = 'goplan_preparation_access_edit';
/** Доступ к разделу Скважина/Куст на просмотр */
export const GOPLAN_DRILLING_CARPET_WELL_CLUSTER_ACCESS_READ = 'goplan_well_cluster_access_read';
/** Доступ к редактированию "Архивных версий" */
export const GOPLAN_GRAPH_SELECT_TEMP_DRAFT_EDIT = 'goplan_graph_select_temp_draft_edit';
export const GOPLAN_GRAPH_SELECT_TEMP_DRAFT_EDIT_ALIAS = 'goplan_edit_archived_versions';
/** Доступ к редактированию настроек цветовой палитры */
export const GOPLAN_COLOR_PALETTE_EDITING = 'goplan_color_palette_editing';
/** Доступ к созданию/редактированию публичных шаблонов таблицы страницы "Скважины" */
export const GOPLAN_TABLE_SYSTEM_TEMPLATES_EDITING = 'goplan_table_system_templates_editing';
